import React from 'react';
import { useAppSelector } from '../../store.model';
import { getGroups, getGroupsByGroupIdSelector } from '../selectors';
import { GroupAPI } from '../api/GroupAPI';
import { GROUP_NOT_VOLATILE_DATA_POOLING_INTERVAL } from '../api/Constants';

/**
 * Get and fetch group from groupID
 * @param deviceId
 * @returns [group, loading, error]
 * 
 * @usage
´´´ts
const { data:groups, isLoading, error} = useGroups()
´´´
 */
export function useGroups(groupId?: string) {
  const { data, ...rest } = GroupAPI.useGetGroupsQuery(undefined, {
    pollingInterval: GROUP_NOT_VOLATILE_DATA_POOLING_INTERVAL,
  });
  const groups = useAppSelector((state) =>
    getGroupsByGroupIdSelector(state, { groupId })
  );
  const treeGroups = useAppSelector(getGroups);
  const dataReturn = groupId ? groups : treeGroups;

  return { data: dataReturn, ...rest } as const;
}
